<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('优惠券类型.优惠券名称')" prop="couponName">
                <a-input
                  v-model="queryParam.couponName"
                  :maxLength="32"
                  :placeholder="$t('通用.输入.请输入') + $t('优惠券类型.优惠券名称')"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('是否过期')" prop="state">
                <a-select v-model="queryParam.state" :placeholder="$t('通用.输入.请选择') + $t('是否过期')">
                  <a-select-option value="0">未过期</a-select-option>
                  <a-select-option value="1">已过期</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-show="advanced">
              <a-form-item :label="$t('优惠券类型.优惠券状态')" prop="status">
                <a-select
                  v-model="queryParam.status"
                  :placeholder="$t('通用.输入.请选择') + $t('优惠券类型.优惠券状态')"
                >
                  <a-select-option value="0">启用</a-select-option>
                  <a-select-option value="1">停用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-show="advanced">
              <a-form-item :label="$t('优惠券类型.使用范围')" prop="rangeType">
                <a-select
                  :placeholder="$t('通用.输入.请选择') + $t('优惠券类型.使用范围')"
                  v-model="queryParam.rangeType"
                  allowClear
                >
                  <a-select-option v-for="(item, index) in customDict.CouponTypeEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-show="advanced">
              <a-form-item :label="$t('优惠领取状态')" prop="type">
                <a-select v-model="queryParam.type" :placeholder="$t('通用.输入.请选择') + $t('优惠领取状态')">
                  <a-select-option value="0">可领用</a-select-option>
                  <a-select-option value="2">已领完</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"
                  ><a-icon type="search" />{{ $t('通用.按钮.查询') }}</a-button
                >
                <a-button style="margin-left: 8px" @click="resetQuery"
                  ><a-icon type="redo" />{{ $t('通用.按钮.重置') }}</a-button
                >
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('通用.按钮.收起') : $t('通用.按钮.展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['coupon:coupontype:add']">
          <a-icon type="plus" />{{ $t('通用.按钮.新增') }}
        </a-button>
        <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['coupon:coupontype:edit']"
        >
          <a-icon type="edit" />{{ $t('通用.按钮.修改') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['coupon:coupontype:remove']">
          <a-icon type="delete" />{{ $t('通用.按钮.删除') }}
        </a-button>
        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['coupon:coupontype:export']">
          <a-icon type="download" />{{$t('通用.按钮.导出')}}
        </a-button>-->
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :scroll="{ x: '100%' }"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="rangeType" slot-scope="text, record">
          <custom-dict-tag :options="customDict.CouponTypeEnum" :value="record.rangeType" />
        </span>
        <span slot="isNewCoupon" slot-scope="text, record">
          <custom-dict-tag :options="customDict.TFEnum" :value="record.isNewCoupon" />
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['coupon:coupontype:edit']">
            {{ $t('通用.按钮.修改') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['coupon:coupontype:changeStatus']" />
          <a @click="changeStatusHandle(record, undefined)" v-hasPermi="['coupon:coupontype:changeStatus']">
            {{ record.status == 0 ? $t('停用') : $t('启用') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['coupon:coupontype:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['coupon:coupontype:remove']">
            {{ $t('通用.按钮.删除') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCouponType, listCouponType, delCouponType, changeStatus } from '@/api/coupon/couponType'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'CouponType',
  components: {
    CustomDictTag,
    CreateForm,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        shopId: undefined,
        couponName: undefined,
        money: undefined,
        count: undefined,
        maxFetch: undefined,
        atLeast: undefined,
        needUserLevel: undefined,
        rangeType: undefined,
        businessId: undefined,
        startTime: undefined,
        endTime: undefined,
        state: undefined,
        isShow: undefined,
        detailMessage: undefined,
        isNewCoupon: undefined,
        pageNum: 1,
        pageSize: 10,
        type: undefined,
      },
      columns: [
        {
          title: this.$t('优惠券类型.优惠券名称'),
          dataIndex: 'couponName',
          ellipsis: true,
          align: 'center',
          width: 150,
        },
        {
          title: this.$t('优惠券类型.发放面额'),
          dataIndex: 'money',
          ellipsis: true,
          align: 'center',
          width: 120,
        },
        {
          title: this.$t('优惠券类型.发放数量'),
          dataIndex: 'count',
          ellipsis: true,
          align: 'center',
          width: 120,
        },
        /*{
          title: this.$t('优惠券类型.每人最大领取个数 0无限制'),
          dataIndex: 'maxFetch',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: this.$t('优惠券类型.满多少元使用'),
          dataIndex: 'atLeast',
          ellipsis: true,
          align: 'center',
          width: 120,
        },
        {
          title: this.$t('优惠券类型.使用范围'),
          dataIndex: 'rangeType',
          scopedSlots: { customRender: 'rangeType' },
          ellipsis: true,
          align: 'center',
          width: 120,
        },
        {
          title: this.$t('优惠券类型.有效日期开始时间'),
          dataIndex: 'startTime',
          ellipsis: true,
          align: 'center',
          width: 120,
        },
        {
          title: this.$t('优惠券类型.有效日期结束时间'),
          dataIndex: 'endTime',
          ellipsis: true,
          align: 'center',
          width: 120,
        },
        {
          title: this.$t('是否过期'),
          dataIndex: 'state',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            if (text === 0) {
              return this.$t('未过期')
            } else {
              return this.$t('已过期')
            }
          },
          width: 120,
        },
        {
          title: this.$t('优惠券类型.优惠券状态'),
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            if (text === 0) {
              return this.$t('启用')
            } else {
              return this.$t('停用')
            }
          },
          width: 120,
        },
        {
          title: this.$t('优惠券剩余数量'),
          dataIndex: 'remainingCount',
          ellipsis: true,
          align: 'center',
          width: 120,
        },
        // {
        //   title: this.$t('优惠券类型.是否新人优惠券'),
        //   dataIndex: 'isNewCoupon',
        //   scopedSlots: { customRender: 'isNewCoupon' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('优惠券类型.创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center',
          width: 150,
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    /** 查询优惠券类型列表 */
    getList() {
      this.loading = true
      pageCouponType(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        shopId: undefined,
        couponName: undefined,
        money: undefined,
        count: undefined,
        maxFetch: undefined,
        atLeast: undefined,
        needUserLevel: undefined,
        rangeType: undefined,
        businessId: undefined,
        startTime: undefined,
        endTime: undefined,
        state: undefined,
        isShow: undefined,
        detailMessage: undefined,
        isNewCoupon: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk() {
          let data = []
          that.ids.map((id) => data.push({ id: id }))
          return delCouponType(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            const message = that.$t('通用.文本.删除成功')
            that.$message.success(message, 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('coupon/coupon/type/export', ...that.queryParam, `优惠券类型_${new Date().getTime()}.xlsx`)
        },
        onCancel() {},
      })
    },
    changeStatusHandle(record) {
      var that = this
      let title = record.status == 0 ? this.$t('停用') : this.$t('启用')
      this.$confirm({
        title: this.$t('确认' + title + record.couponName + '吗？'),
        onOk() {
          let data = []
          changeStatus({ id: record.id, status: record.status == 0 ? 1 : 0 }).then(() => {
            that.handleQuery()
          })
        },
        onCancel() {
          //取消清空删除ids列表
        },
      })
    },
  },
}
</script>
